(() => {
  const numberWords = [
    'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
    'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve'
  ];

  function isSwatchSoldOut(li) {
    if (li.classList.contains('swatch-item-unavailable')) return true;
    if (li.querySelector('.sold-out-badge')) return true;
    const label = (li.getAttribute('aria-label') || li.textContent || '').toLowerCase();
    return /sold\s*out/.test(label);
  }

  function fixSoldOutBadge(card, swatchHost, colorGroup) {
    if (card.__sn2ColorwayPicked) return;
    const badges = card.querySelectorAll('.sn2-soldout-badge');
    if (!badges.length) return;
    const items = colorGroup
      ? colorGroup.querySelectorAll('li.swatch-view-item')
      : swatchHost.querySelectorAll('li.swatch-view-item');
    if (!items || items.length < 2) return;
    let hasAvailable = false;
    items.forEach((li) => {
      if (!isSwatchSoldOut(li)) hasAvailable = true;
    });
    badges.forEach((badge) => {
      if (hasAvailable) {
        badge.style.display = 'none';
        badge.setAttribute('hidden', '');
      } else {
        badge.style.display = '';
        badge.removeAttribute('hidden');
      }
    });
  }

  function formatMoney(cents, moneyFormat) {
    if (cents == null) return '';
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const withDecimals = intPart + '.' + parts[1];
    return (moneyFormat || 'LE {{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, intPart);
  }

  function renderArmamentPriceDOM(priceElem, variant, moneyFormat) {
    const onSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
    const sectionId = priceElem.getAttribute('section-id') || '';
    const discountType = priceElem.__sn2InitialDiscountType || priceElem.getAttribute('discount-value') || 'hide';
    priceElem.__sn2InitialDiscountType = discountType;

    const pct = onSale ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '%' : 'null';
    priceElem.setAttribute('price', String(variant.price));
    priceElem.setAttribute('compare-at', onSale ? String(variant.compare_at_price) : 'null');
    priceElem.setAttribute('discount', pct);
    priceElem.setAttribute('discount-value', discountType);

    const formattedPrice = formatMoney(variant.price, moneyFormat);
    const formattedCompare = onSale ? formatMoney(variant.compare_at_price, moneyFormat) : '';
    const showDiscount = onSale && discountType !== 'hide';

    // Ensure the exact armament-price.liquid DOM structure is intact (restoring if Variant Swatch King replaced it with .price-item)
    let regularWrap = priceElem.querySelector('[data-armada-selector="regular-price-container"]');
    let compareAtWrap = priceElem.querySelector('[data-armada-selector="compare-at-container"]');
    let discountWrap = priceElem.querySelector('[data-armada-selector="discount-amount-container"]');

    if (!regularWrap || !compareAtWrap || priceElem.querySelector('.price-item')) {
      priceElem.innerHTML =
        '<div class="flex flex-row flex-wrap items-baseline justify-center">' +
          '<div class="mr-2" data-armada-selector="regular-price-container" id="price-field">' +
            '<span class="sr-only">' + (onSale ? 'Sale price' : 'Regular price') + '</span>' +
            '<span class="money" data-aid="regular-price" data-armada-selector="price-' + sectionId + '">' + formattedPrice + '</span>' +
          '</div>' +
          '<div class="flex">' +
            '<div class="line-through flex items-center' + (onSale ? '' : ' hidden') + '" data-armada-selector="compare-at-container">' +
              '<span class="sr-only">Regular price</span>' +
              '<span class="opacity-60 text-base font-body" data-aid="compare-at-price" data-armada-selector="compare-at-' + sectionId + '">' + formattedCompare + '</span>' +
            '</div>' +
            '<div data-armada-selector="discount-amount-container" class="flex items-center' + (showDiscount ? '' : ' hidden') + '">' +
              '<span class="ml-2 text-base font-body" data-armada-selector="discount-' + sectionId + '" data-aid="discount-amount">-' + (onSale ? pct : '') + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      return;
    }

    // Never add line-through to regularWrap; only compareAtWrap has line-through
    regularWrap.classList.remove('line-through');
    compareAtWrap.classList.add('line-through');
    if (onSale) {
      compareAtWrap.classList.remove('hidden');
    } else {
      compareAtWrap.classList.add('hidden');
    }
    if (discountWrap) {
      if (showDiscount) discountWrap.classList.remove('hidden');
      else discountWrap.classList.add('hidden');
    }

    const priceSpan = priceElem.querySelector('[data-aid="regular-price"]');
    const compareAtSpan = priceElem.querySelector('[data-aid="compare-at-price"]');
    if (priceSpan) priceSpan.textContent = formattedPrice;
    if (compareAtSpan) compareAtSpan.textContent = formattedCompare;
  }

  function updateCardFromVariant(card, variant, moneyFormat) {
    card.__sn2LastVariant = variant;
    card.__sn2MoneyFormat = moneyFormat;

    const titleBlock = card.querySelector('[data-name="title"]');
    if (titleBlock) {
      const link = titleBlock.querySelector('a');
      if (link) {
        if (variant.url) {
          link.href = variant.url;
        } else if (variant.id) {
          const nextUrl = new URL(link.href, window.location.origin);
          nextUrl.searchParams.set('variant', variant.id);
          link.href = nextUrl.pathname + nextUrl.search;
        }
      }
    }

    const priceElem = card.querySelector('product-price');
    if (priceElem) {
      renderArmamentPriceDOM(priceElem, variant, moneyFormat);
    }

    const onSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
    const imageBox = card.querySelector('[data-name="image"] .aspect-tall')
      || card.querySelector('[data-name="image"] a > div')
      || card.querySelector('[data-name="image"] a');

    // 1. Update SOLD OUT badge
    let soldOutBadge = card.querySelector('.sn2-soldout-badge');
    if (!soldOutBadge && !variant.available && imageBox) {
      soldOutBadge = document.createElement('span');
      soldOutBadge.className = 'sn2-soldout-badge';
      soldOutBadge.setAttribute('aria-label', 'Sold out');
      soldOutBadge.textContent = 'SOLD OUT';
      imageBox.prepend(soldOutBadge);
    }
    if (soldOutBadge) {
      if (variant.available) {
        soldOutBadge.style.display = 'none';
        soldOutBadge.setAttribute('hidden', '');
      } else {
        soldOutBadge.style.display = '';
        soldOutBadge.removeAttribute('hidden');
      }
    }

    // 2. Update SALE badge (hide when sold out or not on sale; show when available and on sale)
    let badgesWrap = card.querySelector('.sn2-card-badges');
    if (!badgesWrap && variant.available && onSale && imageBox) {
      badgesWrap = document.createElement('div');
      badgesWrap.className = 'sn2-card-badges absolute inset-0 z-50 pointer-events-none';
      badgesWrap.innerHTML = '<product-badges data-custom-badges="{}" data-onsale="true" data-available="true"><product-badge class="bg-page text-body"><span>Sale</span></product-badge></product-badges>';
      imageBox.prepend(badgesWrap);
    }
    if (badgesWrap) {
      const pb = badgesWrap.querySelector('product-badges');
      if (!variant.available || !onSale) {
        badgesWrap.style.display = 'none';
        if (pb) {
          pb.setAttribute('data-onsale', 'false');
          pb.setAttribute('data-available', String(Boolean(variant.available)));
        }
      } else {
        badgesWrap.style.display = '';
        if (pb) {
          pb.setAttribute('data-onsale', 'true');
          pb.setAttribute('data-available', 'true');
          if (!pb.querySelector('product-badge')) {
            pb.innerHTML = '<product-badge class="bg-page text-body"><span>Sale</span></product-badge>';
          }
        }
      }
    }
  }

  function updateCard(card) {
    const swatchHost = card.querySelector('variant-swatch-king');
    if (!swatchHost) return;
    if (!card.__sn2Path) card.__sn2Path = cardLinkPath(card);

    // Record initial price state so we can restore if Variant Swatch King mutates <product-price> on initial swatch
    const priceElem = card.querySelector('product-price');
    if (priceElem && !card.__sn2LastVariant) {
      const p = parseInt(priceElem.getAttribute('price') || '0', 10);
      const cRaw = priceElem.getAttribute('compare-at');
      const c = cRaw && cRaw !== 'null' ? parseInt(cRaw, 10) : null;
      const soldOut = Boolean(card.querySelector('.sn2-soldout-badge:not([hidden])'));
      if (p > 0) {
        card.__sn2LastVariant = { price: p, compare_at_price: c, available: !soldOut };
        card.__sn2MoneyFormat = priceElem.getAttribute('money-format') || document.querySelector('gc-cart-popup')?.dataset?.moneyFormat || 'LE {{amount}}';
      }
    }
    if (priceElem && priceElem.querySelector('.price-item') && card.__sn2LastVariant) {
      renderArmamentPriceDOM(priceElem, card.__sn2LastVariant, card.__sn2MoneyFormat || 'LE {{amount}}');
    }

    const colorGroup = Array.from(swatchHost.querySelectorAll('[option-name]')).find(
      (group) => /^(color|colour)(way)?$/i.test(group.getAttribute('option-name')?.trim() || '')
    );
    fixSoldOutBadge(card, swatchHost, colorGroup);
    const count = colorGroup?.querySelectorAll('li.swatch-view-item').length || 0;
    let label = swatchHost.querySelector(':scope > .sn2-colorway-count');

    if (count < 2) {
      label?.remove();
      swatchHost.classList.remove('sn2-has-colorway-count');
      return;
    }

    if (!label) {
      label = document.createElement('span');
      label.className = 'sn2-colorway-count';
      swatchHost.append(label);
    }

    const text = (numberWords[count] || count) + ' color ways';
    if (label.textContent !== text) label.textContent = text;
    swatchHost.classList.add('sn2-has-colorway-count');
  }

  function updateAllCards() {
    document.querySelectorAll('product-card').forEach(updateCard);
  }

  function handleVariantChange(e) {
    const detail = e.detail || {};
    const productId = detail.productId;
    const variant = detail.variant;
    if (!productId || !variant) return;

    const moneyFormat = document.querySelector('gc-cart-popup')?.dataset?.moneyFormat || 'LE {{amount}}';

    document.querySelectorAll('color-swatch').forEach((swatch) => {
      if (swatch.getAttribute('product-id') === String(productId)) {
        const card = swatch.closest('product-card');
        if (card) updateCardFromVariant(card, variant, moneyFormat);
      }
    });
  }

  const productCache = new Map();

  function productPathFromHref(href) {
    try {
      const u = new URL(href, window.location.origin);
      return /\/products\/[^/]+$/.test(u.pathname) ? u.pathname : null;
    } catch (_) {
      return null;
    }
  }

  function fetchProduct(path) {
    if (!productCache.has(path)) {
      productCache.set(
        path,
        fetch(path + '.js', { credentials: 'same-origin' })
          .then((res) => (res.ok ? res.json() : null))
          .catch(() => null)
      );
    }
    return productCache.get(path);
  }

  function cardLinkPath(card) {
    const link = card.querySelector('[data-name="title"] a') || card.querySelector('[data-name="image"] a');
    return link ? productPathFromHref(link.getAttribute('href') || '') : null;
  }

  function applyProductToCard(card, product, moneyFormat, path) {
    card.__sn2ColorwayPicked = true;
    const targetUrl = path || product.url || ('/products/' + product.handle);
    const link = card.querySelector('[data-name="title"] a');
    if (link) {
      link.setAttribute('href', targetUrl);
      link.setAttribute('title', product.title);
      const heading = link.querySelector('h5, h2, h3, [data-aid="product-card-product-heading"]');
      if (heading) {
        heading.textContent = product.title;
      } else {
        link.textContent = product.title;
      }
    }
    const imageLink = card.querySelector('[data-name="image"] a');
    if (imageLink) {
      imageLink.setAttribute('href', targetUrl);
      imageLink.setAttribute('title', product.title);
    }

    // Update image from VSK data or product featured_image if available
    const vskImgData = card.querySelector('.vsk-product-images-data [data-product-handle="' + targetUrl + '"]');
    const featuredImg = vskImgData?.getAttribute('data-featured-image') || product.featured_image;
    if (featuredImg) {
      const imgEl = card.querySelector('[data-name="image"] img.product-card-img');
      if (imgEl) {
        imgEl.src = featuredImg;
        imgEl.removeAttribute('srcset');
      }
    }

    const shown = (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
    if (!shown) return;
    const compareAt = shown.compare_at_price || product.compare_at_price_max || product.compare_at_price || null;
    updateCardFromVariant(
      card,
      {
        price: shown.price,
        compare_at_price: compareAt,
        available: Boolean(product.available),
        url: targetUrl
      },
      moneyFormat
    );
  }

  function syncCardToPath(card, path) {
    if (!path) return;
    card.__sn2TargetPath = path;
    fetchProduct(path).then((product) => {
      if (!product) return;
      if (card.__sn2TargetPath && card.__sn2TargetPath !== path) return;
      card.__sn2Path = path;
      const moneyFormat = document.querySelector('gc-cart-popup')?.dataset?.moneyFormat || 'LE {{amount}}';
      applyProductToCard(card, product, moneyFormat, path);
    });
  }

  function syncCardToLinkedProduct(card) {
    const path = cardLinkPath(card);
    if (!path) return;
    if (card.__sn2Path === path) {
      // Even if path already matches, ensure Variant Swatch King didn't clobber <product-price>
      const priceElem = card.querySelector('product-price');
      if (priceElem && priceElem.querySelector('.price-item') && card.__sn2LastVariant) {
        renderArmamentPriceDOM(priceElem, card.__sn2LastVariant, card.__sn2MoneyFormat || 'LE {{amount}}');
      }
      return;
    }
    syncCardToPath(card, path);
  }

  function watchColorwayInteractions() {
    // 1. Direct click/interaction listener on Variant Swatch King swatches
    document.addEventListener('click', (e) => {
      const sw = e.target instanceof Element ? e.target.closest('.swatch-group-selector[swatch-url], li.swatch-view-item') : null;
      if (!sw) return;
      const selector = sw.matches('.swatch-group-selector') ? sw : sw.querySelector('.swatch-group-selector[swatch-url]');
      const rawUrl = selector?.getAttribute('swatch-url');
      const path = rawUrl ? productPathFromHref(rawUrl) : null;
      const card = sw.closest('product-card');
      if (card && path) {
        syncCardToPath(card, path);
      }
    }, true);

    // 2. Watch href mutations on card links AND childList mutations on <product-price> (when VSK overwrites innerHTML)
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        const el = m.target;
        if (!(el instanceof Element)) continue;
        if (m.type === 'attributes' && el.matches('a') && el.closest('[data-name="title"], [data-name="image"]')) {
          const card = el.closest('product-card');
          if (card && card.querySelector('variant-swatch-king')) syncCardToLinkedProduct(card);
        } else if (m.type === 'childList') {
          const priceElem = el.matches('product-price') ? el : el.closest('product-price');
          if (priceElem && priceElem.querySelector('.price-item')) {
            const card = priceElem.closest('product-card');
            if (card && card.__sn2LastVariant) {
              renderArmamentPriceDOM(priceElem, card.__sn2LastVariant, card.__sn2MoneyFormat || 'LE {{amount}}');
            }
          }
        }
      }
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  let scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateAllCards();
    });
  }

  function start() {
    updateAllCards();
    document.addEventListener('ARMADA:VARIANT:CHANGE', handleVariantChange);
    watchColorwayInteractions();
    new MutationObserver(scheduleUpdate).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-label']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
